/**
 * Provides ability to track using Google analytics.
 * @param {Object} ga
 * @param {Object} config
 * @param {Array|undefined} plugins
 * @param {Object} campaignData
 * @returns {Object}
 */
export default (function (ga, config) {
    var plugins = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var campaignData = arguments[3];

    function trackPageView(_ref) {
        var path = _ref.payload.path;

        ga('set', {
            page: path,
            campaignSource: campaignData.utm_source,
            campaignMedium: campaignData.utm_medium
        });
        ga('send', {
            hitType: 'pageview'
        });
    }

    function trackServerCall(_ref2) {
        var _ref2$payload = _ref2.payload,
            elapsedTime = _ref2$payload.elapsedTime,
            path = _ref2$payload.path,
            method = _ref2$payload.method;

        ga('send', {
            hitType: 'event',
            eventCategory: 'serverCall',
            eventAction: path + ':' + method,
            eventValue: elapsedTime
        });
    }

    function trackServerCallError(_ref3) {
        var _ref3$payload = _ref3.payload,
            elapsedTime = _ref3$payload.elapsedTime,
            path = _ref3$payload.path,
            method = _ref3$payload.method;

        ga('send', {
            hitType: 'event',
            eventCategory: 'serverCallError',
            eventAction: path + ':' + method,
            eventValue: elapsedTime
        });
    }

    function trackWizard(_ref4) {
        var eventName = _ref4.eventName;

        ga('send', {
            hitType: 'event',
            eventCategory: 'wizard',
            eventAction: eventName
        });
    }

    function trackPurchase(_ref5) {
        var _ref5$payload = _ref5.payload,
            id = _ref5$payload.id,
            offering = _ref5$payload.offering,
            taxes = _ref5$payload.taxes,
            total = _ref5$payload.total,
            productName = _ref5$payload.productName;

        ga('ecommerce:addTransaction', {
            id: id,
            revenue: total.amount,
            tax: taxes.amount,
            currency: total.currency
        });
        ga('ecommerce:addItem', {
            id: id,
            name: productName,
            category: offering,
            price: total.amount - taxes.amount,
            currency: total.currency
        });
        ga('ecommerce:send');
    }
    function fieldTrackCallback(_ref6) {
        var _ref6$payload = _ref6.payload,
            path = _ref6$payload.path,
            fieldName = _ref6$payload.fieldName;

        ga('send', {
            hitType: 'event',
            eventCategory: 'fieldTracking',
            eventAction: path + ':' + fieldName

        });
    }

    // Create a new tracker
    ga('create', config);
    plugins.forEach(function (pluginName) {
        return ga('require', pluginName);
    });
    return {
        trackPageView: trackPageView,
        trackServerCall: trackServerCall,
        trackServerCallError: trackServerCallError,
        trackWizard: trackWizard,
        trackPurchase: trackPurchase,
        fieldTrackCallback: fieldTrackCallback
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-js/adapters/GoogleAnalyticsAdapter.js
// module id = 919
// module chunks = 0